import * as React from "react";
import Slider from "@material-ui/lab/Slider";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  withStyles,
} from "@material-ui/core";
import i18n from "i18n";

const styles = () => ({
  infoSubtitle: {
    fontSize: "11px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.67)",
    textTransform: "uppercase" as any,
    fontFamily: "Roboto",
  },
  wbsSubtitle: {
    padding: "20px 0px",
    fontFamily: "Roboto",
    fontSize: "10px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.67)",
  },
  sliderContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 38px",
    gridColumnGap: "20px",
  },
  slider: {
    overflowX: "hidden" as any,
    padding: "6px",
  },
  sliderSpan: {
    textAlign: "center" as any,
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.87)",
    borderBottom: "1px solid #888888",
    paddingBottom: "6px",
    marginTop: "-16px",
  },
  radioGroup: {
    marginTop: "-17px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
  },
  radioLabel: {
    fontFamily: "Roboto",
    fontSize: "10px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.6)",
  },
});

const CalculateProperties = ({
  classes,
  containerClass,
  decimalPlaces,
  roundingRule,
  calculating,
  onChange,
}) => {
  const i18nLabel = i18n.project.rightSideMenu.wbs;

  const handleSliderChange = (ev, value) => {
    if (value) onChange("decimalPlaces", value);
  };

  const handleRadioChange = (ev) => {
    const value = ev.target.value;
    if (value) onChange("roundingRule", value);
  };

  return (
    <div className={containerClass}>
      <Typography className={classes.infoSubtitle}>
        {i18nLabel.title}
      </Typography>
      <Typography
        style={{ paddingTop: "30px !important" }}
        className={classes.wbsSubtitle}
        component="span"
      >
        {i18nLabel.unitCost}
      </Typography>
      <div className={classes.sliderContainer}>
        <Slider
          min={2}
          max={7}
          step={1}
          value={decimalPlaces}
          className={classes.slider}
          onChange={handleSliderChange}
          disabled={calculating}
        />
        <div>
          <Typography className={classes.sliderSpan} component="div">
            {decimalPlaces}
          </Typography>
        </div>
      </div>
      <Typography className={classes.wbsSubtitle} component="span">
        {i18nLabel.roundingRule.title}
      </Typography>
      <RadioGroup
        name="roundingRule"
        className={classes.radioGroup}
        value={roundingRule}
        onChange={handleRadioChange}
      >
        <FormControlLabel
          classes={{ label: classes.radioLabel }}
          value="round"
          disabled={calculating}
          control={<Radio />}
          label={i18nLabel.roundingRule.round}
        />
        <FormControlLabel
          classes={{ label: classes.radioLabel }}
          value="trunc"
          disabled={calculating}
          control={<Radio />}
          label={i18nLabel.roundingRule.trunc}
        />
      </RadioGroup>
    </div>
  );
};

export default withStyles(styles)(CalculateProperties);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/WBSProperties/CalculateProperties.tsx